import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

export default new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior() {
        return { x: 0, y: 0 }
    },
    routes: [
        {
            path:'',
            name:'login',
            component: () => import(/* webpackChunkName: "login" */ './pages/Login.vue'),
        },
        {
            path: '/dashboard',            
            component: () => import(/* webpackChunkName: "dashhome" */ './pages/dashboard/Home.vue'),
            children: [
                {
                    path:'/',
                    name: 'dashboard',
                    component:() => import(/* webpackChunkName: "dashhomelist" */ './pages/dashboard/Home/View.vue'),
                },
                {
                    path:'/orders',
                    //name: 'dashboard',
                    component:() => import(/* webpackChunkName: "dashhomelist" */ './pages/dashboard/Orders.vue'),
                    children:[
                        {
                            path:'',
                            name:'orders',
                            component:() => import(/* webpackChunkName: "dashhomelist" */ './pages/dashboard/Orders/List.vue'),
                        }
                    ]
                },
                {
                    path:'/financeiro',
                    //name: 'dashboard',
                    component:() => import(/* webpackChunkName: "financeiro" */ './pages/dashboard/Financeiro.vue'),
                    children:[
                        {
                            path:'cotacaomensal',
                            component:() => import(/* webpackChunkName: "cotacaomensallist" */ './pages/dashboard/Financeiro/CotacaoMensal.vue'),
                            children:[
                                {
                                    path:'',
                                    name:'cotacaomensal',
                                    component:() => import(/* webpackChunkName: "cotacaomensallist" */ './pages/dashboard/Financeiro/CotacaoMensal/List.vue')                            
                                },
                                {
                                    path:'edit/:partner/:partner_service',
                                    name: 'cotacaomensal_edit',
                                    component: () => import(/* webpackChunkName: "cotacaomensaledit" */ './pages/dashboard/Financeiro/CotacaoMensal/Edit.vue'),
                                }
                            ]
                        },
                        {
                            path:'liberacaocredito',
                            component:() => import(/* webpackChunkName: "liberacaocredito" */ './pages/dashboard/Financeiro/Liberacao.vue'),
                            children:[                                
                                {
                                    path:':status',
                                    name:'liberacaocredito_status',
                                    component:() => import(/* webpackChunkName: "liberacaocredito_status" */ './pages/dashboard/Financeiro/Liberacao/List.vue')                            
                                }
                            ]
                        },
                        {
                            path:'liberacaopagamento',
                            component:() => import(/* webpackChunkName: "liberacaopacaento" */ './pages/dashboard/Financeiro/Liberacao.vue'),
                            children:[                                
                                {
                                    path:':status',
                                    name:'liberacaopagamento_status',
                                    component:() => import(/* webpackChunkName: "liberacaopagamento_status" */ './pages/dashboard/Financeiro/LiberacaoPagamento/List.vue')                            
                                }
                            ]
                        }
                        
                        
                    ]
                },
                {
                    path:'/isrcs',
                    //name: 'dashboard',
                    component:() => import(/* webpackChunkName: "isrc" */ './pages/dashboard/Isrcs.vue'),
                    children:[
                        {
                            path:'',
                            name:'isrcs',
                            component:() => import(/* webpackChunkName: "isrclist" */ './pages/dashboard/Isrcs/List.vue')                            
                        },
                        {
                            path:'edit/:id',
                            name: 'isrc_edit',
                            component: () => import(/* webpackChunkName: "isrclist" */ './pages/dashboard/Isrcs/Edit.vue'),
                        }
                    ]
                },
                {
                    path:'/artists',
                    //name: 'dashboard',
                    component:() => import(/* webpackChunkName: "artists" */ './pages/dashboard/Artists.vue'),
                    children:[
                        {
                            path:'',
                            name:'artists',
                            component:() => import(/* webpackChunkName: "artistslist" */ './pages/dashboard/Artists/List.vue'),
                        }
                    ]
                },
                {
                    path: 'products',
                    //name:'products',
                    component: () => import(/* webpackChunkName: "dashproducts" */ './pages/dashboard/Products.vue'),
                    children: [
                        {
                            path: 'audio/',
                            component: () => import(/* webpackChunkName: "dashprodlist" */ './pages/dashboard/Products/Audio.vue'),
                            children:[
                                { 
                                    path:'/',
                                    name: 'product_list_audio',
                                    component: () => import(/* webpackChunkName: "dashprodlist" */ './pages/dashboard/Products/Audio/ListAudio.vue'),
                                },
                                { 
                                    path:'status/:status',
                                    name: 'product_list_audio_filter_status',
                                    component: () => import(/* webpackChunkName: "dashprodlist" */ './pages/dashboard/Products/Audio/ListAudio.vue'),
                                },
                                {
                                    path:'edit/:id',
                                    name: 'product_edit_audio',
                                    component: () => import(/* webpackChunkName: "producteditaudio" */ './pages/dashboard/Products/Audio/Edit.vue'),
                                }
                            ]
                        },

                        {
                            path: 'video/',
                            component: () => import(/* webpackChunkName: "dashprodvideo" */ './pages/dashboard/Products/Video.vue'),
                            children:[
                                {
                                    path:'',
                                    name: 'product_list_video',
                            component: () => import(/* webpackChunkName: "dashprodlistvideo" */ './pages/dashboard/Products/Video/ListVideo.vue'),
                                },
                                {
                                    path:'edit/:id',
                                    name: 'product_edit_video',
                                    component: () => import(/* webpackChunkName: "producteditvideo" */ './pages/dashboard/Products/Video/Edit.vue'),
                                }
                            ]
                        },
                        {
                            path: 'published',
                            name: 'product_published',
                            component: () => import(/* webpackChunkName: "dashprodpublished" */'./pages/dashboard/Products/Published.vue'),
                        }

                    ]
                },
                {
                    path:'lancamentos',
                    component: () => import(/* webpackChunkName: "dashproducts" */ './pages/dashboard/Products.vue'),
                    children:[
                        {
                            path: 'calendar',
                            name: 'calendar',
                            component: () => import(/* webpackChunkName: "dashprodcalendar" */'./pages/dashboard/Products/Calendar.vue'),
                        },
                        {
                            path: 'proximos',
                            name: 'lancamentos_proximos',
                            component: () => import(/* webpackChunkName: "dashprodcalendar" */'./pages/dashboard/Products/Next.vue'),
                        }
                    ]

                }
                

            ]
        }
    ]
})